import React from "react";
import { East, MoveDownOutlined } from "@mui/icons-material";
import { ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useProfile } from "../../common/useProfile";

const ITEM_HEIGHT = 48;
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function KanbanCardMoverMenu(props) {
    const { action, col, kanban, cartao } = props;
    const prof = useProfile();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleMenuItem(row) {
        const dado = {
            id: cartao.id,
            idColuna: row.id
        }
        handleClose();
        if (action) action( dado );
    }
    return (
        <React.Fragment>
            <MenuItem onClick={handleClick}>
                <ListItemIcon size='small'>
                    <MoveDownOutlined fontSize="small" />
                </ListItemIcon>
                Mover para
            </MenuItem>

            <Menu sx={{ width: 520, maxWidth: '100%' }}
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 10.5,
                            width: '30ch',
                        },
                    },
                    list: {
                        'aria-labelledby': 'long-button',
                    },
                }}
                size='small'
            >
                {kanban && kanban.colunas && kanban.colunas.map( (row, id) =>{
                    if( row.id === col.id) return;
                    if( row.regra ){
                        if( !prof.temAcesso(row.regra)){
                            return;
                        }
                    }
                    return (
                        <MenuItem key={'m-'+id} onClick={() => handleMenuItem(row) }>{row.nome} </MenuItem>
                    )
                })}
                
            </Menu>
        </React.Fragment>
    )
}